import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment from 'moment';

@Component({
  selector: 'app-voucher-payment',
  templateUrl: './voucher-payment.component.html',
  styleUrls: ['./voucher-payment.component.css']
})
export class VoucherPaymentComponent implements OnInit {
  ItemList = [];
    keyval: any;

    PaymentModelSearch = {
        AccID: 0,
        FromDate: moment(new Date()).format("DD-MMM-YYYY"),
        ToDate: moment(new Date()).format("DD-MMM-YYYY"),
        ChequeNo: '',
        Narration: '',
        Print: "",
        ChequeName: "",
        AccName: "",
        VoucherTypeID:0,
    };
    PaymentModel = {
        TransDetID: 0,
        CreditAccID: 0,
        DebitAccID: 0,
        Amount: 0,
        AccID: 0,
        PaymentThroughID:0,
        IsChequeName: false,
        IsChqExist: false,
        DebitAmount: 0,
        Narration: '',
        ChequeDate: moment(new Date()).format("DD-MMM-YYYY"),
        ChequeNo: '',
        ChequeName: '',
        CreditNarration: '',
        DebitNarration: '',
        TotalDebitAmt: 0,
        TransID: 0,
        VoucherTypeID: 2,
        TransDate: moment(new Date()).format("DD-MMM-YYYY"),
    };
    ItemListAll: any;
    AccCode = '';
    AccName = '';
    CashAccName = '';
    Submitted = false;
    IsChqExist = false;
    ExceedMsg = '';
    constructor(private accService: AccountingService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }


    getkeys(event) {
        this.keyval = event.keyCode;
        if (this.keyval == 13) {
            this.Add();
        }
    }

    changeChequeDate() {
        this.PaymentModel.ChequeDate = moment(new Date(this.PaymentModel.TransDate)).format("DD-MMM-YYYY");
    }
    Edit(item) {
       
        this.PaymentModel.VoucherTypeID=item.VoucherTypeID
        this.PaymentModel.TransDate = moment(new Date(item.TransDate)).format("DD-MMM-YYYY");
        this.PaymentModel.ChequeNo = item.ChequeNo;
        this.PaymentModel.ChequeDate = moment(new Date(item.ChequeDate)).format("DD-MMM-YYYY");
        this.PaymentModel.ChequeName = item.ChequeName;
        this.PaymentModel.IsChequeName = item.IsChequeName;
        this.PaymentModel.CreditAccID = item.CreditAccID;
        this.PaymentModel.Amount = item.Amount;
        this.PaymentModel.PaymentThroughID = item.PaymentThroughID;
        this.PaymentModel.Narration = item.Narration;
        this.PaymentModel.TransID = item.TransID;
        this.spinnerService.show()
        this.ItemList = [];
        this.accService.GetVoucherPaymentDetails(this.PaymentModel.TransID).subscribe((response) => {
            this.ItemListAll = response.JournaVoucherDetailsList;
            setTimeout(() => {
                this.spinnerService.hide();
                this.globalHelper.CheckActionStatus(response);
                for (var i = 0; i < this.ItemListAll.length; i++) {
                    if (this.ItemListAll[i].DebitAmt > 0) {
                        var itembo = {
                            TransDetID: this.ItemListAll[i].TransDetID,
                            AccID: this.ItemListAll[i].AccID,
                            AccName: this.ItemListAll[i].AccName,
                            AccCode: this.ItemListAll[i].AccCode,
                            Amount: this.ItemListAll[i].DebitAmt,
                            Narration: this.ItemListAll[i].Narration,
                        }
                        this.AccName = this.ItemListAll[i].AccName;
                        this.ItemList.push(itembo)
                    }
                    else {
                        this.CashAccName = this.ItemListAll[i].AccName;
                        this.PaymentModel.CreditAccID = this.ItemListAll[i].AccID;
                        this.PaymentModel.TransDetID = this.ItemListAll[i].TransDetID;
                        this.PaymentModel.Amount = this.ItemListAll[i].Amount;
                        this.PaymentModel.TransDate = moment(new Date(this.ItemListAll[i].TransDate)).format("DD-MMM-YYYY");
                    }
                    //this.ItemListAll[i].Amount =this.ItemListAll[i].DebitAmt > 0 ?this.ItemListAll[i].DebitAmt :this.ItemListAll[i].CreditAmt;
                }
                if (this.AccName != this.PaymentModel.ChequeName) {
                    this.PaymentModel.IsChequeName = true;
                }


                this.SumTotalAmount();
            }, 10);

        });

    }


    Clear() {
        this.PaymentModel.CreditAccID = 0;
        this.PaymentModel.PaymentThroughID = 0;
        this.PaymentModel.DebitAccID = 0;
        this.PaymentModel.Amount = 0;
        this.PaymentModel.Narration = '';
        this.PaymentModel.ChequeName = '';
        this.PaymentModel.IsChequeName = false;
        this.PaymentModel.ChequeDate = moment(new Date()).format("DD-MMM-YYYY");
        this.PaymentModel.TransDate = moment(new Date()).format("DD-MMM-YYYY");
        this.PaymentModel.ChequeNo = '';
        this.PaymentModel.DebitNarration = '';
        this.PaymentModel.DebitAmount = 0;
        this.AccCode = '';
        this.AccName = '';
        this.CashAccName = '';
        this.Submitted = false;
        this.IsChqExist = false;
        this.ExceedMsg = '';
        this.ItemList = [];
    };

    onSelect(item) {
        this.AccName = item.AccName;
        this.PaymentModel.DebitAccID = item.AccID;
    }

    onSelectName(item) {

        this.AccCode = item.AccCode;
        this.PaymentModel.DebitAccID = item.AccID;
        this.PaymentModel.AccID = item.AccID;
    }

    onSelectBank(item) {
        this.PaymentModel.CreditAccID = item.ItemId;
        this.GetVoucherPayment();
    }

    onSelectBankSearch(item) {
        this.PaymentModelSearch.AccID = item.ItemId;
    }
    SearchBankAccName = ""
    ClearSearch() {
        this.PaymentModelSearch.AccID = 0;
        this.PaymentModelSearch.FromDate = moment(new Date()).format("DD-MMM-YYYY"),
            this.PaymentModelSearch.ToDate = moment(new Date()).format("DD-MMM-YYYY"),
            this.SearchBankAccName = '';
        this.PaymentModelSearch.ChequeNo = '';
        this.PaymentModelSearch.Narration = '';
    };

    ValidateAdd() {
        return this.PaymentModel.AccID == 0
           
            || this.PaymentModel.DebitAmount <= 0
            || this.PaymentModel.CreditAccID == 0;
    };
    Submitted1 = false;
    Add() {
        this.Submitted = true;
        this.Submitted1 = true;
        this.ExceedMsg = "";

        if (!this.ValidateAdd()) {
            this.Submitted = false;
            this.Submitted1 = false;
            var itembo = {
                TransDetID: 0,
                AccCode: this.AccCode,
                AccName: this.AccName,
                AccID: this.PaymentModel.DebitAccID,
                Amount: this.PaymentModel.DebitAmount,
                Narration: this.PaymentModel.DebitNarration,
            }
            if (this.PaymentModel.IsChequeName == false) {
                this.PaymentModel.ChequeName = this.AccName;
            }
            if (true) {
                this.AccCode = "";
                this.AccName = "";
                this.PaymentModel.DebitAmount = 0;
                this.PaymentModel.DebitNarration = '';
                this.ItemList.push(itembo);
                this.SumTotalAmount();
            }

        }

    }

    removeRow(index) {
        this.ItemList.splice(index, 1);
        this.SumTotalAmount();
    };

    SumTotalAmount() {
        var TotalDebitAmt = 0;
        for (var i = 0; i < this.ItemList.length; i++) {
            TotalDebitAmt = TotalDebitAmt + parseFloat(this.ItemList[i].Amount);
        }
        this.PaymentModel.TotalDebitAmt = TotalDebitAmt;
        this.PaymentModel.Amount = this.PaymentModel.TotalDebitAmt;
    }

    ValidateDropdownSave() {
       
        if(this.PaymentModel.VoucherTypeID==2){
            return this.PaymentModel.CreditAccID == 0 || this.PaymentModel.Amount == 0
            ||  this.PaymentModel.ChequeDate == '' || this.PaymentModel.ChequeNo == '' || this.PaymentModel.ChequeName == ''

        }
        if(this.PaymentModel.VoucherTypeID==4){
            return this.PaymentModel.CreditAccID == 0 || this.PaymentModel.Amount == 0
             ;
        }
        

        
    };


    ErrorMessage = "";
    loadingSave = false;
    SavePayment() {
        this.ErrorMessage = "";
        this.Submitted = true;
        if (this.ItemList.length > 0 && this.PaymentModel.IsChequeName == false) {
            this.PaymentModel.ChequeName = this.ItemList[0].AccName;
        }
        if (!this.ValidateDropdownSave()) {

            if (this.PaymentModel.TotalDebitAmt == this.PaymentModel.Amount) {
                this.loadingSave = true;
                this.spinnerService.show();
                this.PaymentModel.ChequeDate = this.PaymentModel.ChequeDate != null ? moment(this.PaymentModel.ChequeDate).format('DD-MMM-YYYY') : '';
                this.PaymentModel.TransDate = this.PaymentModel.TransDate != null ? moment(this.PaymentModel.TransDate).format('DD-MMM-YYYY') : '';
                this.accService.SaveVoucherPayment(JSON.stringify(this.PaymentModel), JSON.stringify(this.ItemList)).subscribe((response) => {
                    this.ErrorMessage = response.ErrorMessage;

                    if (this.ErrorMessage != "chequeexists") {

                        this.Clear();
                        this.ItemList = [];
                        this.GetVoucherPayment();
                        if (response.webResponse.Status) {
                            this.Submitted = false;
                            this.globalHelper.CheckActionStatus(response);

                        }
                    }
                    else {

                        var r = confirm("cheque no already exists!  Are you sure enter this cheque no?");
                        if (r == true) {
                            this.PaymentModel.IsChqExist = true;
                            this.accService.SaveVoucherPayment(JSON.stringify(this.PaymentModel), JSON.stringify(this.ItemList)).subscribe((response) => {


                                setTimeout(() => {
                                    this.spinnerService.hide();
                                    this.loadingSave = false;

                                }, 10);
                                if (response.webResponse.Status) {
                                    this.Submitted = false;
                                    this.globalHelper.CheckActionStatus(response);
                                    this.Clear();
                                    this.ItemList = [];
                                    this.GetVoucherPayment();
                                    this.ErrorMessage = '';
                                }

                            });



                        } else {
                            this.PaymentModel.IsChqExist = false;
                        }
                    }
                    setTimeout(() => {
                        this.spinnerService.hide();
                        this.loadingSave = false;

                    }, 10);


                });
            }
        }
    }
    loadingSearch = false;
    BankPaymentList: any;
    GetVoucherPayment() {
        this.loadingSearch = true;
        this.spinnerService.show();
        this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
        this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null  && this.PaymentModelSearch.ToDate != null? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
       this.spinnerService.show();
        this.accService.GetVoucherPayment(JSON.stringify(this.PaymentModelSearch)).subscribe((response) => {
            this.BankPaymentList = response.BankPaymentList;
            this.spinnerService.hide();
            setTimeout(() => {
                this.spinnerService.hide();
                this.loadingSearch = false;
                this.globalHelper.CheckActionStatus(response);
            }, 10);
        });
    };



    AccountList: any;
    GetAccount() {
        this.lookupService.GetLookupsList('Acc', '').subscribe((data) => {
            this.AccountList = data.LookupItems;
            this.AccountList.splice(0, 1);
        });
    }
    AccList: any;
    GetBankAccount() {
        this.lookupService.GetLookupsList('Account', '').subscribe((data) => {
            this.AccList = data.LookupItems;
            this.AccList.splice(0, 1);
        });
    }
    
    GetCashAccount() {
        this.lookupService.GetLookupsList('CashAcc', '').subscribe((data) => {
            this.AccList = data.LookupItems;
            this.AccList.splice(0, 1);
        });
    }
    ChangeMode(){

      if(this.PaymentModel.VoucherTypeID==4){
        this.GetCashAccount();
      }
      if(this.PaymentModel.VoucherTypeID==2){
        this.GetBankAccount();
      }
    }
    Print = "";
    TransID = 0;
    GetVoucherPrint(item) {
        this.Print = 'P';
        this.TransID = item.TransID;
        this.TransID = item.TransID;
        var url = "voucherpaymentprint?ReportType=PrintVoucherPayment&TransID=" + this.TransID;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    }

    PrintList() {
        this.PaymentModelSearch.Print = 'P';
        this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate!='' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
        this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate != '' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
        
       
        var url = "voucherpaymentlistprint?ReportType=PrintVoucherPayment&FromDate=" + this.PaymentModelSearch.FromDate + "&ToDate=" + this.PaymentModelSearch.ToDate + "&Print=" + this.PaymentModelSearch.Print+ "&VoucherTypeID=" + this.PaymentModelSearch.VoucherTypeID;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    };
    TotalDebitAmt = 0;
    TotalCreditAmt = 0;

    Views = {
        TransDate: new Date(),
        Cancel:"",
        CancelRemarks:"",
    }
    VoucherNo = "";
    TransType = "";
    JournaVoucherDetailsList: any;
    GetVoucherDetails(item) {
        this.TotalDebitAmt = item.Amount;
        this.TotalCreditAmt = item.Amount;
        this.Views.TransDate = item.CreatedOn;
        this.Views.Cancel = item.Cancel;
        this.Views.CancelRemarks = item.CancelRemarks;
        this.TransID = item.TransID;
        this.VoucherNo = item.VoucherNo;
        this.TransType = item.TransType;
        this.spinnerService.show();
        this.accService.GetVoucherPaymentDetails(this.TransID).subscribe((response) => {
            this.JournaVoucherDetailsList = response.JournaVoucherDetailsList;

            this.globalHelper.CheckActionStatus(response);
            this.spinnerService.hide();
        });
    }
    TrDate:any;
    GetVoucherCancel  (item) {
        this.submitCancel = false;
       
        this.CancelModel.TransID = item.TransID;

        this.TrDate = item.CreatedOn;
        this.TransID = item.TransID;
        this.VoucherNo = item.VoucherNo;
        this.TransType = item.TransType;
    }
    loadingCancel = false;
    CancelModel = {
        CancelRemarks: '',
        TransID: 0,
    }
    submitCancel = false;
    CancelVoucher  () {
        this.submitCancel = true;
        if (this.CancelModel.CancelRemarks != '') {

            this.loadingCancel = true;
            this.submitCancel = false;
            this.accService.CancelVoucher(JSON.stringify(this.CancelModel)).subscribe((response) => {
                this.globalHelper.CheckActionStatus(response);
                this.GetVoucherPayment();

                if(response.webResponse.Status){
                    this.CancelModel = {
                        CancelRemarks: '',
                        TransID: 0,
                    }
                }
              
                this.loadingCancel = false;
                
            });
          
         
        }

    }
    ngOnInit() {
        setTimeout(() => {
     
            this.PaymentModelSearch.FromDate = moment(this.globalHelper.GetLoginToken().SessionStartDate).format("DD-MMM-YYYY");
      
            this.PaymentModelSearch.ToDate = moment(this.globalHelper.GetLoginToken().SessionEndDate).format("DD-MMM-YYYY");
                       
          }, 300);
        this.GetAccount();
        this.ChangeMode();
        this.GetPaymentThrough();
    }
    PaymentThroughList: any;
    GetPaymentThrough() {
        this.lookupService.GetLookupsList('PaymentThrough', '').subscribe((data) => {
            this.PaymentThroughList = data.LookupItems;
            
        });
    }

}
